export default __webpack_public_path__ + "static/napkin-459857745ebe37fb3ef64eb084b78699.mp4";